import { Injectable } from '@angular/core';
import { Headers, Request, Response, RequestMethod, RequestOptionsArgs, RequestOptions } from '@angular/http';
import { environment } from '../../../environments/environment';
import { ContactPersonalInformationDc } from '../models/contact/contact-personal-information-dc.model';
import { ContactFileInformationDc } from "../models/contact/contact-file-information-dc.model";
import { HttpHelper } from '../../common/helpers/http.helper';
import { SessionHelper } from '../../common/helpers/session.helper';
import { ModuleNameConstant } from '../../security/module-name.constant';
import { HtmlImportDc } from '../models/contact/html-import-dc.model';
import { ContactStepDetailsDc } from '../models/contact/contact-step-details-dc.model';
import { ContactToDoDetailsDc } from '../models/contact/contact-todo-details-dc.model';
import { EmployeeService } from './employee.service';
import { ContactGroupUpdateInformation } from '../models/contact/contact-group-update-information.model';
import { BehaviorSubject } from 'rxjs';


@Injectable()
export class ContactService {
    public isAddModalOpen = new BehaviorSubject(false);
    public showSearchBarAndLogoutBtn = new BehaviorSubject(true);

    public contactPermission;
    public showWelcomeModal: boolean = false;
    constructor(private _httpHelper: HttpHelper, private employeeService: EmployeeService) {
    }
    
    public saveAffiliateNoteInfo(dataObj) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "contactcommunication/contactnote/setshowtoaffiliatettwoandthreeportal";
        return this._httpHelper.put(environment.APIBaseUrl + url, dataObj, reqOption);
    }

    public changeCreditorName(creditorObj) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "scraping/accounthistory/updateImportcreditorname";
        return this._httpHelper.put(environment.APIBaseUrl + url, creditorObj, reqOption);
    }

    public fetchReport(contactId: Number, userName: string='', isFromBoat = false, packageId = 0) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contact/fetchjsoncreditreport?contactid=" + contactId + "&isfrombot=" + isFromBoat + '&packageid='+ packageId;
        if (userName != '') {
            url += "&username=" + userName.trim();
        }
        return this._httpHelper.get(encodeURI(environment.APIBaseUrl + url), reqOption);
    }

    public fetchReportWithProgress(contactId: Number, userName: string='', isFromBoat = false) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contact/fetchjsoncreditreport?contactid=" + contactId+"&isfrombot="+isFromBoat;
        if(userName != ''){
            url += "&username=" + userName.trim();
        }
        return this._httpHelper.getWithProgress(encodeURI(environment.APIBaseUrl + url), reqOption);
    }

    public checkCreditReportStatus(contactId: Number){
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contact/checkanycreditreportuploaded?contactid=" + contactId;
        return this._httpHelper.get(encodeURI(environment.APIBaseUrl + url), reqOption);
    }

    public getAltGoalChatBotStatus(AuthenticationId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "chatbot/altgoal/getchatcompletedstatus/" + AuthenticationId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public updateTodoSequence(todoList: ContactToDoDetailsDc[]) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "roadmap/contacttodo/updatesequenceorder";
        return this._httpHelper.put(environment.APIBaseUrl + url, todoList, reqOption);
    }

    public sendSMSTagToAc(Obj: { PrimaryEmail: string, PhoneAllowed: string, ContactId: Number }) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "contact/contactpersonalinformation/smsoptout";
        return this._httpHelper.put(environment.APIBaseUrl + url, Obj, reqOption);
    }

    public getContactPersonalInformationById(id: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contact/contactpersonalinformation/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getAffiliatePersonalInformationById(id: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/affiliate/getaffiliatedetailbyid/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getJointContactDetailById(contactid: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contact/contactpersonalinformation/jointcontactdetail/" + contactid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getContactDetailById(contactid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contact/contactpersonalinformation/jointcontactdetail/" + contactid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }
    public addContactByPopup(addContactPersonalInformation: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contact/contactpersonalinformation/addcontactbypopup"
        return this._httpHelper.post(environment.APIBaseUrl + url, addContactPersonalInformation, reqOption);
    }
    /////////////////////////////////contact list without advance search////////
    // public getAllContactListWithOutAdvanceSearch(setfromdate: string, settodate: string, userId: Number) {
    //     let headers: Headers = new Headers();
    //     let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
    //     let url = "contact/contactpersonalinformation/contactlistbycontacttypeid?fromdate=" + setfromdate + "&todate=" + settodate
    //         + "&userId=" + userId;
    //     return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    // }
    public getContactProfileDetailByContactId(contactid: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contact/contactpersonalinformation/myprofiledetails/" + contactid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }


    /////////////////////////////////contact list with advance search////////
    public contactListByAdvanceSearch(contactAdvnaceSearchDc: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contact/contactpersonalinformation/contactlistbyadvancesearch/";
        return this._httpHelper.post(environment.APIBaseUrl + url, contactAdvnaceSearchDc, reqOption);
    }


    public updateBotTeamsStrategies(data: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "chatbot/updatebotteamstrategies";
        return this._httpHelper.post(environment.APIBaseUrl + url, data, reqOption);
    }


    public addUpdateContactPersonalInfo(contactPersonalInformationDc: ContactPersonalInformationDc) {
        let file: FormData = contactPersonalInformationDc.DrivingLicencePath;
        contactPersonalInformationDc.DrivingLicencePath = "";
        contactPersonalInformationDc.AddressProofPath = "";
        contactPersonalInformationDc.SSNPath = "";

        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(contactPersonalInformationDc));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contact/contactpersonalinformation/addupdatecontactpersonalinfo"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);
    }

    public getAllContactName(userId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contact/contactpersonalinformation/getallcontactnamelist/" + userId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getAllCustomerDetailByContactId(contactId: Number) {
        let userId = localStorage.getItem('UserId');
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contact/contactpersonalinformation/getallcontactpersonalinformationbyid?contactid=" + contactId + "&userid=" + userId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }


    public updateContactProfileDetail(contactPersonalInformationDc, formData) {
        let file: any = [];
        if (typeof formData === 'object') {
            file = formData;
        }
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(contactPersonalInformationDc));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "customerprofile/updateprofile";
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);
    }

    public completeProfileSetup(profileData: any){
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "customerportal/setunsetsetupcompleted"
        return this._httpHelper.put(environment.APIBaseUrl + url, profileData, reqOption);
    }

    /// contact file
    public getContactFileInformationById(id: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contact/contactfileinformation/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addContactFileInfo(contactFileInformationDc: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contact/contactfileinformation/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, contactFileInformationDc, reqOption);
    }

    public deleteContactFullDetailFromAllTablesById(deleteContactDetailDc: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contact/contactfileinformation/delete";
        return this._httpHelper.post(environment.APIBaseUrl + url, deleteContactDetailDc, reqOption);
    }

    //// ContactTask ////
    public getContactTaskById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "strategy/contacttask/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getContactTaskListByContactId(searchContactTaskDc: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contact/contacttask/tasklistbycontactid/";
        return this._httpHelper.post(environment.APIBaseUrl + url, searchContactTaskDc, reqOption);
    }

    public getALlContactTaskList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contact/contacttask/getallcontacttasklist/";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getAllContactDropdownLists() {
        const user = SessionHelper.getUser();
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        // let url = "affiliate/getaffiliatepagedropdownlists";
        let url = `contact/getcontactpagedropdownlistsbyuser?userId=${user.UserId}&userType=${user.UserType}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getAllContactTaskList(TaskCategoryId: Number, EmployeeId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contact/contacttask/getallcontacttasklist?taskCategoryId=" + TaskCategoryId + "&employeeId=" + EmployeeId;
        return this._httpHelper.post(environment.APIBaseUrl + url, null, reqOption);
    }

    public addContactTask(contactTaskDc: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contact/contacttask/addupdate";
        return this._httpHelper.post(environment.APIBaseUrl + url, contactTaskDc, reqOption);
    }

    public deleteContactTaskById(contacttaskId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "contact/contacttask/deletccontacttask/" + contacttaskId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public UploadHtmlFile(htmlImportDc: HtmlImportDc) {
        let file: FormData = htmlImportDc.HTMLFileName;
        htmlImportDc.HTMLFileName = "";
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(htmlImportDc));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "importhtml/uploadhtml"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);
    }

    public getContactStatusDetailsByContactId(contactid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/contactstatusdetails/detail/" + contactid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    /////Contact Column Hide Show Detail
    public getContactColumnHideShowDetailById(employeeId: Number, userType:string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `contact/contactcolumnhideshowdetail/details?employeeid=${employeeId}&usertype=${userType}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }
    public addContactColumnHideShowDetail(ContactHideShowColumnDc: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contact/contactcolumnhideshowdetail/addupdate";
        return this._httpHelper.post(environment.APIBaseUrl + url, ContactHideShowColumnDc, reqOption);
    }
    ///////////end


    //////////////////////////////
    //Contact Communication Note//
    /////////////////////////////


    public getContactNoteByContactId(companyid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactcommunication/contactnote/details/" + companyid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }
    ///////////////////get all list of contact communication on crm dashboard
    public getAllCommunicationListOnCrmDashboard() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactcommunication/communication/allnoteattachmentlist";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    // public deleteContactNoteById(noteid:Number) {
    //     let headers: Headers = new Headers();
    //     let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
    //     let url = "contact/branchinformation/delete/" + noteid;
    //     return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    // }

    public addUpdateContactNote(note: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactcommunication/contactnote/addupdate";
        return this._httpHelper.post(environment.APIBaseUrl + url, note, reqOption);
    }

    public deleteNoteByContactId(noteid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "contactcommunication/contactnote/delete/" + noteid;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }
    //////////////Contact Roadmap//////////////

    public AddCommonRoadmapChecklist(addContactCommonRoadmapChecklistDc: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contactroadmap/contactcommonroadmapchecklist/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addContactCommonRoadmapChecklistDc, reqOption);
    }

    public getCommonRoadmapChecklistById(CommonRoadmapChecklistId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactroadmap/contactcommonroadmapchecklist/details/" + CommonRoadmapChecklistId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }
    public getChecklistDetailByContactId(contactid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactroadmap/contactroadmapchecklistdetail/details/" + contactid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }


    public getSpContactNoteByContactId(contactid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactcommunication/spcontactnoteaffiliate/details/" + contactid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getSpContactNoteAccordingToSequence(contactId: Number, affiliateId: Number=0, pageNo: Number=1, pageSize: Number=10) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `contactcommunication/spcontactnotebysequence/details?contactid=${contactId}&affiliateid=${affiliateId}&pageno=${pageNo}&pagesize=${pageSize}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getMyReffertalContactNotes(contactId: Number, affiliateId: Number=0, pageNo: Number=1, pageSize: Number=10) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `contactcommunication/spcontactnotebysequenceaffportal/details?contactid=${contactId}&affiliateid=${affiliateId}&pageno=${pageNo}&pagesize=${pageSize}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public UpdateSequenceContactNote(id: Number, PIN: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contactcommunication/contactnote/updateSequenceContactNote?contactid=" + id + "&keypin=" + PIN;
        return this._httpHelper.post(environment.APIBaseUrl + url, null, reqOption);
    }
    //////////Add Positive Account
    public addPositiveAccount(AddPositiveAccount: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "positiveaccount/addpositveaccount/addupdate";
        return this._httpHelper.post(environment.APIBaseUrl + url, AddPositiveAccount, reqOption);
    }

    /////////// Save Single Row Dispute Letter Information from negative Account

    public addDisputeLetterInformationList(addDisputeLettersInformationDcsList: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "negativeaccount/disputeletterinformation/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addDisputeLettersInformationDcsList, reqOption);
    }

    ///////////Save All Dispute Letter Information from negative Account

    public saveAllDisputeLetterInformationList(addDisputeLettersInformationDcsList: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "negativeaccount/disputeletterinformation/savealldisputeletter"
        return this._httpHelper.post(environment.APIBaseUrl + url, addDisputeLettersInformationDcsList, reqOption);
    }

    ////  Attachment Master////
    public getAttachmentMasterListByContactId(ContactId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactcommunication/attachmentmaster/getattachmentlist/" + ContactId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getAttachmentMasterWithOutHTMLReports(ContactId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactcommunication/attachmentmaster/getattachmentwithouthtmlreport/" + ContactId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getAttachmentMasterById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactcommunication/attachmentmaster/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateAttachmentMaster(addAttachmentMaster: any) {
        let file: FormData = addAttachmentMaster.AttachmentName;
        addAttachmentMaster.AttachmentName = "";
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(addAttachmentMaster));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contactcommunication/attachmentmaster/addupdate"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);
    }

    public deleteAttachmentMasterByFileName(AttachmentFileName: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "contactcommunication/attachmentmaster/delete?AttachmentFileName=" + AttachmentFileName;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }


    public deleteHtmlScrapingFile(AttachmentId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "contactcommunication/scrapinghtmlfile/delete?Attachmentid=" + AttachmentId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }


    public getAttachmentTypeList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactcommunication/attachmenttype/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getContactToDoListByContactId(contactId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "roadmap/contacttodo/detailsbycontactid/" + contactId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public saveContactStepDetails(contactStepDetailsDc: ContactStepDetailsDc) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "roadmap/contactstep/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, contactStepDetailsDc, reqOption);
    }

    public saveContactToDoDetail(contactToDoDetailsDc: ContactToDoDetailsDc) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "roadmap/contacttodo/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, contactToDoDetailsDc, reqOption);
    }

    public getContactToDoListByContactid(contactId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "roadmap/contacttodo/detailsbycontactid/" + contactId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getContactToDoListByProgramId(programId: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "roadmap/todomaster/getbyprogramid?programId=" + programId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public deleteContactToDoListById(contactTodoid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "roadmap/contacttodo/delete/" + contactTodoid
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public getContactStepDetail(contactId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "roadmap/contactstep/detailsbycontactid/" + contactId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }
    //////////////////Get Last Round id ////////////////////////////
    public GetLastRoundIdByContactId(contactid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactroadmap/lastroundidbycontactid/" + contactid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getCustomerDetailForLaunchPortal(contactid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contact/CustomerDetails/getinformationforcustomerporatllaunch/" + contactid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getCustomerHistoryDetail(contactid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactcommunication/ContactHistory/" + contactid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }



    public setContactPermission(permission) {
        this.contactPermission = permission;
    }

    public getContactModulePermission() {
        let userProfileDetail = this.employeeService.getUserProfileDetail();
        let roleId = (userProfileDetail) ? userProfileDetail.RoleId : SessionHelper.getUserRoleId();
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `permission/getsubmodules?roleId=${roleId}&moduleName=${ModuleNameConstant.Contacts}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }


    public completeContactTaskById(contacttaskId: Number, status: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = `contact/contacttask/updatecontacttaskstatus?id=${contacttaskId}&taskStatusId=${status}`;
        return this._httpHelper.put(environment.APIBaseUrl + url, {}, reqOption);
    }

    public updateMultipleContacts(contactGroupUpdateInformation: ContactGroupUpdateInformation) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "contact/contactgroupupdate";
        return this._httpHelper.put(environment.APIBaseUrl + url, contactGroupUpdateInformation, reqOption);
    }

    getOnlyMyContacts(allContacts: any, categoryId: any = 0) {
        let currentUser = SessionHelper.getUser();
        let userFullName = SessionHelper.getUserFullName();
        return (categoryId != 0) ? allContacts.filter(x => ((x.CreatedBy == userFullName || x.AccountManagerId == currentUser.UserId ||
            x.CreditAdvisorId == currentUser.UserId || x.CaseManagerId == currentUser.UserId ||
            x.MarketerId == currentUser.UserId || x.RelationshipManagerId == currentUser.UserId) && x.ContactTypeId == categoryId)) : allContacts.filter(x => (x.CreatedBy == SessionHelper.getUserFullName() || x.AccountManagerId == currentUser.UserId ||
                x.CreditAdvisorId == currentUser.UserId || x.CaseManagerId == currentUser.UserId ||
                x.MarketerId == currentUser.UserId || x.RelationshipManagerId == currentUser.UserId));
    }

    getSameProgramContacts(allContacts: any, categoryId: any = 0) {
        let currentUser = SessionHelper.getUser();
        let userProfileDetail = this.employeeService.getUserProfileDetail();
        let userFullName = SessionHelper.getUserFullName();
        return allContacts.filter(x => (x.CreatedBy == userFullName || x.AccountManagerId == currentUser.UserId ||
            x.CreditAdvisorId == currentUser.UserId || x.CaseManagerId == currentUser.UserId ||
            x.MarketerId == currentUser.UserId || x.RelationshipManagerId == currentUser.UserId || (userProfileDetail.ProgramIds && userProfileDetail.ProgramIds.includes(x.ProgramId))));
    }

    getAllContacts(allContacts: any, categoryId: any = 0) {
        let currentUser = SessionHelper.getUser();
        return (categoryId != 0) ? allContacts.filter(x => ((x.AccountManagerId == currentUser.UserId ||
            x.CreditAdvisorId == currentUser.UserId || x.CaseManagerId == currentUser.UserId ||
            x.MarketerId == currentUser.UserId || x.RelationshipManagerId == currentUser.UserId
            || x.CreditAdvisorId == null || x.AccountManagerId == null || x.CaseManagerId == null || x.CreatedBy == null) && (x.ContactTypeId == categoryId))) : allContacts.filter(x => (x.AccountManagerId == currentUser.UserId ||
                x.CreditAdvisorId == currentUser.UserId || x.CaseManagerId == currentUser.UserId ||
                x.MarketerId == currentUser.UserId || x.RelationshipManagerId == currentUser.UserId
                || x.CreditAdvisorId == null || x.AccountManagerId == null || x.CaseManagerId == null || x.CreatedBy == null));
    }

    setNotesShowToCustomer(object) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "contactcommunication/contactnote/setshowtocustomerportal";
        return this._httpHelper.put(environment.APIBaseUrl + url, object, reqOption);
    }

    setNotesShowToAffiliate(object) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "contactcommunication/contactnote/setshowtoaffiliateportal";
        return this._httpHelper.put(environment.APIBaseUrl + url, object, reqOption);
    }

    setVideoShowToCustomer(object) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "commeducation/setshowtocustomerportal";
        return this._httpHelper.put(environment.APIBaseUrl + url, object, reqOption);
    }

    getGlobalCustomerFilterData(object) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "contact/contactpersonalinformation/searchcontactdashboard";
        return this._httpHelper.post(environment.APIBaseUrl + url, object, reqOption);
    }

    dashboardSearch(employeeId, searchText) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `dashboard/search?employeeId=${employeeId}&searchText=${searchText}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public disableImportantNotesAttachmentFlag(object) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "negativeaccount/unimportantnotesattachment";
        return this._httpHelper.put(environment.APIBaseUrl + url, object, reqOption);
    }

    public disableImportantNotesAttachments(object) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "negativeaccount/unimportantnotesattachmentById";
        return this._httpHelper.put(environment.APIBaseUrl + url, object, reqOption);
    }

    public getCommunication(contactid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/communication/bindcommunicationbycontactid/" + contactid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getCommunicationDatabyId(communicationId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/communication/detailsbyid/" + communicationId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getCreditorListBySearchText(searchText: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "strategy/creditors/bindcreditor?search=" + searchText;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getAffilateByAltGoalId(altGoalId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `altgoalmaster/getaffiliatesbyaltgoalid?altgoalId=${altGoalId}&employeeId=${SessionHelper.getUserId()}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getBillingStatusLists() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/billingstatus/details";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getRangeGoalsData() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/estimatedtimeline/details";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public setDefaultGoalAddContactTeamAssigned(contactObj) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "teamassigned/setdefaultgoaladdcontactteamassigned";
        return this._httpHelper.put(environment.APIBaseUrl + url, contactObj, reqOption);
    }

    public getAttachmentMasterListByAffiliateId(affiliateId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/communication/getallattachmentmaster/" + affiliateId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateAffiliateAttachmentMaster(addAffiliateAttachmentMaster: any) {
        let file: FormData = addAffiliateAttachmentMaster.AttachmentName;
        addAffiliateAttachmentMaster.AttachmentName = "";
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(addAffiliateAttachmentMaster));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliate/communication/attachmentmaster"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);
    }

    public deleteAffiliateAttachmentMasterByFileName(AttachmentFileName: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "affiliate/communication/attachmentmaster/delete?AttachmentFileName=" + AttachmentFileName;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public setResetIsImportant(data) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "contactcommunication/contactnote/setresetisimportant";
        return this._httpHelper.put(environment.APIBaseUrl + url, data, reqOption);
    }

    public deleteCreditReportFile(CreditReportObj) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "negativeaccount/undohtmldetails";
        return this._httpHelper.post(environment.APIBaseUrl + url, CreditReportObj, reqOption);
    }

    public getEmailSentHistory(contactId:Number,Type:string, pageNo: Number=1, pageSize: Number = 1000){
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "emailsenthistory/getsenthistory?userId=" + contactId + '&userType=' + Type + "&pageno=" + pageNo + "&pagesize=" + pageSize;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public checkEmailIsInUse(email:string, userId = 0, userType: string = 'Contact') {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `user/IsEmailAlreadyInUse?Email=${email}&UserId=${userId}&UserType=${userType}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getEmailTemplates(userId: Number, userType: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `emailtemplate/bindemailtemplatebycondition?userId=${userId}&userType=${userType}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }


    public sendContactEmail(emailData: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "emailsenthistory/quicksend";
        return this._httpHelper.post(environment.APIBaseUrl + url, emailData, reqOption);
    }

    public deleteEmail(historyId: Number){
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "emailsenthistory/delete/" + historyId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public setApikey(data: any){
      let headers: Headers = new Headers();
      let reqOption: RequestOptions = new RequestOptions({
        method: RequestMethod.Get,
        headers: headers,
      });
      let url = "user/setapikey";
      return this._httpHelper.put(
        environment.APIBaseUrl + url,
        data,
        reqOption
      );
    }

    public getApiKey(userId: Number, userType: string) {
      let headers: Headers = new Headers();
      let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
      let url = `user/getapikey?userid=${userId}&userType=${userType}`;
      return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getCustomerContracts(contactId: Number){
      let headers: Headers = new Headers();
      let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
      let url = `contractdocument/getsignaturebycontactid/${contactId}`;
      return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }


    public getSetupCompletedStatus(contactId: Number){
      let headers: Headers = new Headers();
      let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
      let url = `customerportal/getsetupcompletedstatus/${contactId}`;
      return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public updateCreditMaximizerStatus(statusData: any){
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contact/contactfileinformation/updatestatus"
        return this._httpHelper.put(environment.APIBaseUrl + url, statusData, reqOption);      
    }

    public updateCreditMaximizerFlag(statusData: any){
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "user/setetunsethascustomerleftcrmflag";
        return this._httpHelper.put(environment.APIBaseUrl + url, statusData, reqOption);      
    }

    public getJointContactList(programId: Number) {
        let headers: Headers = new Headers();
        programId = programId ? programId : 0;
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contact/contactpersonalinformation/bindcontactbyprogramid?programId=" + programId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public updateContactProgress(data: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "customerportal/snapshotbtndetails/updateyourprogress";
        return this._httpHelper.put(environment.APIBaseUrl + url, data, reqOption);
    }

    public upgradeMembership(data: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "customerbilling/billingdetails/upgradepackage";
        return this._httpHelper.put(environment.APIBaseUrl + url, data, reqOption);
    }

    public upgradePackage(data: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "upgradepackagetobe/contact";
        return this._httpHelper.post(environment.APIBaseUrl + url, data, reqOption);
    }

    public saveContactBudget(data: any){
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "customerprofile/updatebudget";
        return this._httpHelper.put(environment.APIBaseUrl + url, data, reqOption);
    }

    public saveContactAddresses(data: any){
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contact/address/addupdate";
        return this._httpHelper.post(environment.APIBaseUrl + url, data, reqOption);
    }

    public getContactAddresses(contactId: Number){
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `contact/address/${contactId}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public checkIsEmailExist(email: string, userId: number = 0, userType: string,IsitFromCUC: boolean = false){
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `user/IsEmailAlreadyInUse?Email=${email}&UserId=0&UserType=${userType}&IsitFromCUC=${IsitFromCUC}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public updateMailPackage(data) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "customerprint/undomailedpackageorletterdownloaded";
        return this._httpHelper.post(environment.APIBaseUrl + url, data, reqOption);
    }

    public createWelcomeLetter(contactId){
        let headers = new Headers();
        let reqOption = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "customerprint/createwelcomeletter";
        return this._httpHelper.post(environment.APIBaseUrl + url, {ContactId: contactId}, reqOption);
    }

    public arrayToCAMSignup(data) {
        let headers = new Headers();
        let reqOption = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "array/cam/signup";
        return this._httpHelper.post(environment.APIBaseUrl + url, data, reqOption);
    }

    public checkIsUsernameExist(username: string){
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `user/IsUserNameAlreadyInUse?userName=${username}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getCreditAnalysis(contactId: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `array/getcreditanalysis?contactId=${contactId}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public updateContactStatus(data: any){
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `contact/contactfileinformation/updatestatus`;
        //return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
        return this._httpHelper.put(environment.APIBaseUrl + url, data, reqOption);
    }

    public updateContactRound(data: any){
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `contact/contactfileinformation/updateround`;
        //return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
        return this._httpHelper.put(environment.APIBaseUrl + url, data, reqOption);
    }

    public isUserExistWithSameProgram(data){
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `array/cam/checkcontactexistswithsameprogram`;
        //return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
        return this._httpHelper.post(environment.APIBaseUrl + url, data, reqOption);
    }
}



// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/crm/services/contact.service.ts